import { OperationType } from '~/types';
import { operationEmojis } from '~/utils';
import Emoji from './Emoji';

const LiveFeedEmoji: React.FC<{ type: OperationType }> = ({ type }) => (
  <Emoji v={ operationEmojis[type] } />
);

export default LiveFeedEmoji;
